import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";

import { Menu, Icon, Image } from "semantic-ui-react";

import * as commonVar from "libs/commonVar";

import classNames from "classnames/bind";
import styles from "./AdminMenu.css";
const cx = classNames.bind(styles);

class AdminMenu extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { activeItem, onClickItem } = this.props;
    return (
      <div className={cx("admin-menu-box")}>
        <Menu fluid vertical secondary borderless className={cx("admin-menu")}>
          <Menu.Item
            className="admin-item"
            name="basicconf"
            active={activeItem === "basicconf"}
            onClick={onClickItem}
          >
            {defineMessages(
              formatMessage({ id: "AdminMenu_1", defaultMessage: "기본설정" })
            )}
            <Icon name="settings" />
          </Menu.Item>
          <Menu.Item
            className="admin-item"
            name="smtpconf"
            active={activeItem === "smtpconf"}
            onClick={onClickItem}
          >
            SMTP
            <Icon name="mail outline" />
          </Menu.Item>
          <Menu.Item
            className="admin-item"
            name="examtemplate/examtemplateMail"
            active={activeItem === "examtemplate/examtemplateMail"}
            onClick={onClickItem}
          >
            {defineMessages(
              formatMessage({
                id: "AdminMenu_2",
                defaultMessage: "훈련 템플릿",
              })
            )}
            <Icon name="object group" />
          </Menu.Item>
          <Menu.Item className="phishing">
            <Menu.Menu>
              <Menu.Item
                className={cx("admin-item", "lower")}
                name="examtemplate/examtemplatePhishing"
                active={activeItem === "examtemplate/examtemplatePhishing"}
                onClick={onClickItem}
              >
                {defineMessages(
                  formatMessage({
                    id: "MyPageMenu_7",
                    defaultMessage: "피싱 페이지",
                  })
                )}
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>
          <Menu.Item className="attach">
            <Menu.Menu>
              <Menu.Item
                name="examtemplate/examtemplateAttach"
                active={activeItem === "examtemplate/examtemplateAttach"}
                onClick={onClickItem}
              >
                {defineMessages(
                  formatMessage({
                    id: "AdminMenu_8",
                    defaultMessage: "첨부파일",
                  })
                )}
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>
          {commonVar.isEdu === 1 && (
            <Menu.Item
              className="admin-item"
              name="edutemplate"
              active={activeItem === "edutemplate"}
              onClick={onClickItem}
            >
              {defineMessages(
                formatMessage({
                  id: "MyPageMenu_11",
                  defaultMessage: "교육 템플릿",
                })
              )}
              <Icon name="object group" />
            </Menu.Item>
          )}
          <Menu.Item
            className="admin-item"
            name="user"
            active={activeItem === "user"}
            onClick={onClickItem}
          >
            {defineMessages(
              formatMessage({ id: "AdminMenu_3", defaultMessage: "사용자" })
            )}
            <Icon name="user outline" />
          </Menu.Item>
          <Menu.Item
            className="admin-item"
            name="target"
            active={activeItem === "target"}
            onClick={onClickItem}
          >
            {defineMessages(
              formatMessage({ id: "AdminMenu_9", defaultMessage: "대상자" })
            )}
            <Icon name="target" />
          </Menu.Item>
          <Menu.Item
            className="admin-item"
            name="license"
            active={activeItem === "license"}
            onClick={onClickItem}
          >
            {defineMessages(
              formatMessage({ id: "AdminMenu_4", defaultMessage: "라이센스" })
            )}
            <Icon name="privacy" />
          </Menu.Item>
          <Menu.Item className="phishing">
            <Menu.Menu>
              <Menu.Item
                className={cx("admin-item", "lower")}
                name="license/config"
                active={activeItem === "license/config"}
                onClick={onClickItem}
              >
                {defineMessages(
                  formatMessage({ id: "MyPageMenu_8", defaultMessage: "설정" })
                )}
              </Menu.Item>
            </Menu.Menu>
          </Menu.Item>

          {commonVar.isJapan !== 1 && (
            <Menu.Item
              className="admin-item"
              name="sync"
              active={activeItem === "sync"}
              onClick={onClickItem}
            >
              {defineMessages(
                formatMessage({
                  id: "ConfigSync_1",
                  defaultMessage: "대상자 연동",
                })
              )}
              <Icon name="linkify" />
            </Menu.Item>
          )}

          <Menu.Item
            className="admin-item"
            name="log"
            active={activeItem === "log"}
            onClick={onClickItem}
          >
            {defineMessages(
              formatMessage({ id: "AdminMenu_5", defaultMessage: "로그" })
            )}
            <Icon name="file text outline" />
          </Menu.Item>
          {commonVar.isSaas === 1 && (
            <Menu.Item className="admin-item">
              {defineMessages(
                formatMessage({ id: "AdminMenu_6", defaultMessage: "주요현황" })
              )}
              <Icon name="bar chart" />
              <Menu.Menu>
                <Menu.Item
                  name="status/monit"
                  active={activeItem === "status/monit"}
                  onClick={onClickItem}
                >
                  Monit
                </Menu.Item>
                <Menu.Item
                  name="status/netdata"
                  active={activeItem === "status/netdata"}
                  onClick={onClickItem}
                >
                  netdata
                </Menu.Item>
                <Menu.Item
                  name="status/rabbitmq"
                  active={activeItem === "status/rabbitmq"}
                  onClick={onClickItem}
                >
                  RabbitMQ
                </Menu.Item>
              </Menu.Menu>
            </Menu.Item>
          )}
          <Menu.Item
            className="admin-item"
            name="api"
            active={activeItem === "api"}
            onClick={onClickItem}
          >
            API
            <Icon name="grid layout" />
          </Menu.Item>
        </Menu>
        {/* 머드픽스 버전 정보 */}
        <div style={{ padding: "15px 20px 10px" }}>
          <div className={cx("bold font-size-20", "align-item-center")}>
            <span className={cx("inline-block mr-5")}>
              <Image src={"/img/logo/mf_logo.png"} />
            </span>
            V1.0
          </div>
          <div className={cx("mt-10 bold")}>MudFix Manager: V1.0</div>
          <div className={cx("mt-3 bold")}>MudFix Attach: V1.0</div>
          <div className={cx("mt-3 bold")}>
            Update: {commonVar.updateVersion}
          </div>
        </div>
      </div>
    );
  }
}

AdminMenu.propTypes = {
  activeItem: PropTypes.string,
};
AdminMenu.defaultProps = {
  activeItem: "basicconf",
};

export default injectIntl(AdminMenu);



// WEBPACK FOOTER //
// ./src/script/components/admin/AdminMenu.js